/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D digital clock
 */

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Text from "./Text";

const Clock = React.memo(
    ({ width, textSizeDecimal, textColor, ...otherAttributes }) => {
        const [time, setTime] = useState("");
        const timeUpdater = () => {
            const dateFormatter = new Intl.DateTimeFormat("en", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: false,
                timeZoneName: "short"
            });
            const dateString = dateFormatter.format(Date.now());
            setTime(dateString);
        };
        useEffect(() => {
            const timer = window.setInterval(timeUpdater, 1000);
            return () => {
                window.clearInterval(timer);
            };
        });

        return (
            <a-entity class="Clock" {...otherAttributes}>
                <Text
                    width={width}
                    text={time}
                    color={textColor}
                    sizeDecimal={textSizeDecimal}
                />
            </a-entity>
        );
    }
);

Clock.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    textSizeDecimal: PropTypes.number.isRequired
};

export default Clock;
